// onshape-panel-diagnosis.js — the two sentences the retired Onshape context
// card existed to say, kept without the card (Alex, 2026-10-08: "remove the
// ONSHAPE CONTEXT card and move what we need if any in selected part").
//
// What was kept, and why only this:
//   actionUrlProblems — a broken registration (workspaceId missing, ctx unset,
//     a parameter bled into configuration). Without it the panel falls back to
//     "paste the URL" with no reason, which is the afternoon-long guess the card
//     was built to stop. Shown in that fallback and in Selected part.
//   liveVerdict — whether Onshape's live SELECTION reaches the panel (ON-42),
//     one sentence. Shown in Selected part, which is where a missing selection
//     is noticed.
// Dropped: the token-by-token table and the theme/locale rows. They answered
// "what arrived" once the registrations were being set up; the problems list
// below says what is WRONG, which is the only part a working panel needs.
// Zero calls: reads window.location.search and the selection hook's state.

const LITERAL_RE = /^[{(]\$\w+[)}]$/;

const NEEDED = [
  { key: 'documentId', note: 'the document' },
  { key: 'workspaceId', note: 'required — the top cards look up did/wid/eid' },
  { key: 'elementId', note: 'the tab you are in' },
];

export function actionUrlProblems(search = window.location.search) {
  const params = new URLSearchParams(search);
  const problems = [];
  for (const t of NEEDED) {
    const raw = params.get(t.key);
    if (raw == null) problems.push(`${t.key} is missing from the Action URL — ${t.note}`);
    else if (LITERAL_RE.test(raw.trim())) problems.push(`${t.key} is not substituted — ${t.note}`);
  }
  const ctx = params.get('ctx');
  if (!ctx) problems.push('ctx is not set — add ctx=document / ctx=part / ctx=instance so the panel knows which registration it is.');
  const cfg = params.get('configuration');
  if (cfg && cfg.includes('&')) problems.push('configuration contains "&" — a parameter after {$configuration} bled into it. Move {$configuration} last.');
  return problems;
}

// One sentence per state of useOnshapeSelection() (onshape-selection.js).
export function liveVerdict(live) {
  if (!live) return null;
  if (live.status === 'outside') return 'Not inside Onshape — nothing to listen to.';
  if (live.status === 'no-ids') return 'documentId / workspaceId / elementId missing — the handshake was not sent, so Onshape will send nothing.';
  if (String(live.handshake || '').startsWith('failed')) return `Handshake ${live.handshake}.`;
  if (!live.total) return 'Listening — no message from Onshape yet. Click one whole part: if nothing changes, the selection is not reaching this panel.';
  if (live.last && !live.last.trusted && !live.count) return `Messages arrive, but from ${live.last.origin} — not Onshape's origin, so they are ignored.`;
  if (!live.count) return `Messages arrive from Onshape, but none is a selection (last one: ${live.last?.name}). This context may not send selections.`;
  if (!live.selection) return 'A selection arrived, but its format is not recognised.';
  return null; // a recognised selection — the card itself says what it is
}
